(function userModifyControllerDefinition() {
    'use strict';
    angular.module('User')
        .controller('UserModifyController', [
            '$scope', 'config', '$state', '$translate', 'errorsExtend', 'adminUserService', '$stateParams', 'authExtend', 'adminOrganizationalUnitService',
            function userModifyController($scope, config, $state, $translate, errors, adminUserService, $stateParams, authExtend, adminOrganizationalUnitService) {
                $scope.title = 'UserModify';
                $scope.enableControls = true;
                $scope.userOu =
                    {
                        organizationalUnitName: '',
                    };

                $scope.requiredOu = authExtend.getOrganizationId() ? true : false;

                adminUserService.getById($stateParams.id).then(function (result) {
                    $scope.userOu = result;
                    if ($scope.userOu.organizationalUnitId !== undefined && $scope.userOu.organizationalUnitId !== null) {                        
                        adminOrganizationalUnitService.getById($scope.userOu.organizationalUnitId).then(function getOk(result) {
                            $scope.userOu.securityLevelConfig = result.securityLevelConfig;
                        }, function getError(error) {
                            errors.showError(error);
                        });
                    };

                }, function (error) {
                    errors.showError(error);
                    $state.go('user-find');
                });

                $scope.validMails = function () {
                    if ($scope.userOu.mail) {
                        if ($scope.userOu.mail !== $scope.userOu.mailConfirm) {
                            $scope.userForm.email2.$invalid = true;
                            $scope.userForm.email2.$valid = false;
                            return false;
                        } else {
                            $scope.userForm.email2.$invalid = false;
                            $scope.userForm.email2.$valid = true;
                            return true;
                        }
                    }
                    return false;
                }

                $scope.save = function () {
                    //lo separo pq quiero que se ejecuten siempre los 2
                    var mailIsValid = $scope.validMails();

                    if (!$scope.userForm.$valid || !mailIsValid) {
                        $scope.userForm.$setSubmitted();
                        errors.showError('VerifyFormData');
                        return false;
                    }

                    return adminUserService.modify($scope.userOu).then(function () {
                        $state.go('user-find');
                    }, function (error) {
                        errors.showError(error);
                    });
                };

                $scope.cancel = function () {
                    $state.go("user-find");
                };

                $scope.enable = function (userOU) {
                    return $scope.enable_disable(userOU, true);
                }

                $scope.disable = function (userOU) {
                    return $scope.enable_disable(userOU, false);
                }

                $scope.enable_disable = function (userOU, enabled) {
                    return adminUserService.getById(userOU.id).then(function (result) {
                        var userOu = result;
                        userOu.enabled = enabled;

                        return adminUserService.modify(userOu).then(function () {
                            userOU.enabled = enabled;
                            $state.go('user-find');
                        }, function (error) {
                            errors.showError(error);
                        });
                    });
                }
            }
        ]);
})();